export { default as SectionMainCarousel } from './SectionMainCarousel'
